var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboard = function SvgOnboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    fill: "#181818",
    stroke: "#ffc83d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.645,
    cy: 16.558,
    rx: 2.234,
    ry: 6.591,
    fill: "#714D37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.604,
    cy: 16.558,
    rx: 2.234,
    ry: 6.591,
    fill: "#714D37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.661,
    cy: 11.944,
    rx: 4.98,
    ry: 5.785,
    fill: "#BC8259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.148 12.713c.176-.586.073-4.491 0-6.371 0 0 .147-.22.55-.22.402 0 .585.22.585.22-.036 1.892-.088 5.815 0 6.371.11.696 2.197 2.417 2.673 3.479.476 1.061.44 4.503-.476 5.053-.915.549-2.16 0-2.893 0-.732 0-2.05.659-2.929 0-.878-.66-.805-3.955-.476-5.053.33-1.099 2.746-2.747 2.966-3.479Z",
    fill: "#EFE2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.592 18.892c0 .445.053 1.164-.398 1.448-.532.334-1.285.037-1.462-.223",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.596 19.291c-.044.31.48.905 1.33.798.852-.106 1.106-.71 1.195-.931",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.624,
    cy: 17.253,
    r: 1.721,
    fill: "#281408"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.151,
    cy: 12.896,
    r: 0.513,
    fill: "#281408"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.098,
    cy: 12.896,
    r: 0.513,
    fill: "#281408"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.71 12.208c-1.122 0-.646-.406-2.889-.406-.896-.042-1.8.253-2.14.406.17.913.836 2.739 2.14 2.739 1.631 0 2.48-2.03 2.889-2.03.407 0 1.29 2.03 2.717 2.03 1.142 0 1.903-1.826 2.14-2.74-.271-.135-1.08-.405-2.14-.405-1.325 0-1.596.406-2.717.406Z",
    fill: "#181818"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.11 14.727 1.025-2.893h.256c.176 0 .22.013.256.037-.341 1.025-.93 3.098-1.135 3.039-.205-.059-.403-.146-.403-.183ZM16.235 14.434l.989-2.636h.256c.176 0 .22.012.256.036-.341 1.026-.966 2.915-1.171 2.856-.205-.058-.33-.22-.33-.256Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 8.903,
    y: 15.533,
    width: 11.442,
    height: 11.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 5.681,
    y: 11.798,
    width: 17.886,
    height: 11.149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export { SvgOnboard as ReactComponent };
export default "data:image/svg+xml;base64,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";